import { Component, OnInit, ViewChild } from '@angular/core';

import { MarcroDataComponent } from 'app/market-level/marcro-data/marcro-data.component';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { CpmService } from '../../service/cpm.service';
import { ExportExcelService } from '../../service/export-excel.service';
@Component({
  selector: 'app-marcro-data-econ',
  templateUrl: './marcro-data-econ.component.html',
  styleUrls: ['./marcro-data-econ.component.scss']
})
export class MarcroDataEconComponent implements OnInit {
  @ViewChild(MarcroDataComponent) marcroData: MarcroDataComponent;

  constructor(
    private router: Router,
    private cpmService: CpmService,
    private excelService: ExportExcelService
  ) { }

  ngOnInit() { }

  exportFunctionsMacroData() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailMacroData(
        this.cpmService
      )
    );
    arrayOfFunctions.set(
      'print',
      this.exportPrintMacroData()
    );
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfMacroData()
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelMacroData(
        this.marcroData
      )
    );
    return arrayOfFunctions;
  }

  exportEmailMacroData = function (service) {
    return function mailMacroData() {
      service.saveMacroDataEconPdfFile().then(filename => {
        const subject = 'Macro-Data';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };

  exportPrintMacroData = function () {
    return function macrodataPrint() {
      const popupWin = window.open(
        `/#/marcroData/`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfMacroData = function () {
    const service = this.cpmService;
    return function macrodataPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/marcroData`
      );
    };
  };

  exportExcelMacroData(marcroData) {
    return function excelMacroData() {
      marcroData.dataToExcel()
    };
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/marcro-data-econ/marcro-data-econ.component.ts